export default __webpack_public_path__ + "static/popup-zomer-2025-adfefd56e5c50cb22b948f94af376f91.png";